import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { TermsConditionComponent } from './components/terms-condition/terms-condition.component';
import { OtpComponent } from './components/otp/otp.component';

@NgModule({
  declarations: [OtpComponent, TermsConditionComponent],
  imports: [
    FlexLayoutModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatCheckboxModule,
    FormsModule,
    CommonModule,
    HttpClientModule,
    MatIconModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    CommonModule,
    MatButtonModule,
    MatListModule,
  ],
  exports: [OtpComponent, TermsConditionComponent],
})
export class SdcModule {}
